import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import fetch from './../../fetch';
import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';

import { GET_COUPON, GET_COUPON_SUCCESS, GET_COUPON_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant';

function* getCoupon({ payload }) {
  console.log('payload', payload);
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/couponsInfo`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload.params,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({ type: GET_COUPON_SUCCESS, payload: response?.data });
    } else {
      yield put({ type: GET_COUPON_ERROR, payload: response.data.message });
    }
  } catch (error) {
    yield put({ type: GET_COUPON_ERROR, payload: error });
  }
}

export function* watchGetCoupon() {
  yield takeEvery(GET_COUPON, getCoupon);
}

function* getCouponSaga() {
  yield all([fork(watchGetCoupon)]);
}

export default getCouponSaga;
